/**
 * 模型管理
 * @type {{}}
 */
import Vue from "vue";
import { Input, Icon, Select, Option, Message, Table, Page, Modal,Button,Switch,CheckboxGroup,Checkbox,Poptip } from "view-design";
import { modelListColumns, getModelListService, addModelService,updateModelService,delModelService } from "@/service/business-service";
Vue.component('Input', Input);
Vue.component('Icon', Icon);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Table', Table);
Vue.component('Page', Page);
Vue.component('Modal', Modal);
Vue.component('Button', Button);
Vue.component('onSwitch', Switch);
Vue.component('Checkbox', Checkbox);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Poptip', Poptip);
import { downLoadBatch } from "@/utils/tools";
import { onAsynUploadFiles } from "@/utils/request-function";
import { systemUploadType } from "@/service/system-service";
import { getFileAiModelDownLoadService } from "@/service/business-service";
import { getFileUploadProgressService } from "@/service/device-info-service";
const ModelList = {
    name:'ModelList',
    data() {
        return {
            modelLoading:false, //loading
            modelListColumns:modelListColumns, //模型列表显示字段
            modelModalVisible:false, //新增/编辑弹框状态
            businessInfoModalVisible:false, //详情弹框状态
            editLoading:false, //编辑loading
            userPowerGroup:[], //选择的权限数据
            manufacturerArray:[], //生产厂家数据
            selectAllCancel:[], //全选时的临时存储
            modelListArray:{}, //模型列表数据
            roleListArray:[], //权限列表
            btnStatus:false, //按钮状态
            modelHeight:0,
            qrCodeVisible:false, //code modal 可显示
            speedSingleVisible:false, //单文件上传进度可显示
            QRCode:'',
            speedVisible:false,
            completeAsync:0,
            logoSrc:require("@/assets/Icon/logo-img.png"),
            logoAppSrc:'',
            nodeName:'',
            fileName:'',
            modelEditParams:{
                id:'',
                name:'',
                filePath:'',
                useNum:0,
            },
            modelListParams:{ //提交的数据集
                checkInput:[],//选择的数据列表项
                name:'',  //用户名
                currentPage: 1,  //当前页
                displayNumber:10 // 显示条数
            }
        }
    },
    created() {
        this.onModelList().then()
        this.onTableHeight()
    },
    mounted() {
        window.addEventListener('resize', this.onTableHeight)
    },
    methods: {
        /**
         * 计算table高度
         */
        onTableHeight(){
            this.modelHeight = window.innerHeight - 184
            this.windowWidth = window.innerWidth
        },
        /**
         * 重置
         */
        onReset() {
            this.modelListParams.name = ''
            this.onModelList().then()
        },
        /**
         * 点击上传
         */
        choiceImg(){
            this.$refs.model.dispatchEvent(new MouseEvent('click'))
        },
        /**
         * 添加模型
         */
        onAddModel(){
            this.speedVisible = false;
            this.btnStatus = true;
            this.modelEditParams.filePath = ''
            this.modelEditParams.name = ''
            this.completeAsync = 0
            this.modelModalVisible = true
        },
        /**
         * 编辑模型
         * @param row
         */
        onEditList(row){
            this.speedVisible = true;
            this.btnStatus = false;
            this.modelEditParams.filePath = row.filePath
            this.modelEditParams.name = row.name
            this.modelEditParams.useNum = row.useNum
            this.completeAsync = 100
            this.fileName = row.filePath
            this.modelEditParams.id = row.id
            this.modelModalVisible = true
        },
        /**
         * 点击全选时触发
         * selection: 以选项数据
         * @param selection
         */
        onSelectAll(selection) {
            this.selectAllCancel = selection
            for(let key in selection){
                let flag = true
                for(let index in this.modelListParams.checkInput){
                    if(selection[key].id === this.modelListParams.checkInput[index]){
                        flag = false
                    }
                }
                if(flag){
                    this.modelListParams.checkInput.push(selection[key].id)
                }
            }
        },
        /**
         * 点击取消全选时触发
         * selection: 以选项数据
         * @param selection
         */
        onSelectAllCancel() {
            let selection = this.selectAllCancel
            for(let key in selection){
                for(let index in this.modelListParams.checkInput){
                    if(selection[key].id === this.modelListParams.checkInput[index]){
                        this.modelListParams.checkInput.splice(index,1);
                    }
                }
            }
        },
        /**
         * 选中某以一项时触发
         * selection: 以选项数据
         * row: 刚选择的数据
         * some() 方法用于检测数组中的元素是否满足指定条件
         * 注意： some() 不会对空数组进行检测。
         * 注意： some() 不会改变原始数组。
         * @param selection，row
         */
        onSelect(selection,row) {
            let mediaList = this.modelListParams.checkInput.some((e)=>{
                return e.id === row.id
            })
            if(!mediaList){
                this.modelListParams.checkInput.push(row.id)
            }
        },
        /**
         * 取消选中某一项时触发
         * selection: 以选项数据
         * row: 取消选择的项数据
         * 遍历当前选中数组 如有相同则在当前数组的指定位置进行删除
         * @param selection，row
         */
        onSelectCancel(selection,row) {
            for(let key in this.modelListParams.checkInput){
                if(this.modelListParams.checkInput[key] === row.id){
                    this.modelListParams.checkInput.splice(key,1);
                }
            }
        },
        /**
         * 下载文件
         */
        onDownLoadFile(row){
            // this.onImageUrl(row).then()
            this.onFileDownLoadService([row.id],'',row).then()
        },
        /**
         * 删除模型
         * @param id
         */
        onFileDelete(id){
            Modal.confirm({
                title: '提示',
                content: '<p>您确定要删除这个模型吗？</p>',
                onOk: () => {
                    this.onDelModelService(id).then()
                }
            });
        },
        /**
         * 批量下载文件
         */
        onBatchDownLoad(name){
            if(this.modelListParams.checkInput.length === 0){
                Message.warning('请选择要下载的模型')
                return
            }
            this.onFileDownLoadService(this.modelListParams.checkInput,name).then()
        },
        /**
         * 搜索
         */
        onSearch(){
            this.onModelList().then()
        },
        /**
         * 提交验证
         */
        onSubmitCheck() {
            if(this.modelEditParams.name === ''){
                Message.warning('请输入模型名称！');
                return;
            }
            if(this.modelEditParams.filePath === ''){
                Message.warning('请上传模型！');
                return;
            }
            if(this.btnStatus){
                this.onAddBusinessService().then()
            }else{
                this.onUpdateModelService().then()
            }
        },
        /**
         * 发送当前页
         * @param number
         */
        onSearchPage(number){
            this.modelListParams.currentPage = number
            this.onModelList().then()
        },
        /**
         * 发送每页显示的条数
         * @param number
         */
        onSearchPageSize(number){
            this.modelListParams.displayNumber = number
            this.onModelList().then()
        },
        validateZipRarFile(file) {
            if (!file) return false;

            // 1. 定义允许的 后缀名 和 MIME类型
            const allowedExt = ['zip', 'rar'];
            // 常见的 zip/rar MIME 类型（覆盖绝大多数场景）
            const allowedMimeTypes = [
                'application/zip',
                'application/x-zip-compressed',
                'application/x-rar-compressed',
                'application/octet-stream' // 部分浏览器 rar 会识别为此类型
            ];

            // 2. 获取文件后缀（转小写，避免大小写问题）
            const fileExtension = file.name.split('.').pop().toLowerCase();

            // 3. 验证：后缀合法 + MIME类型合法
            const isExtValid = allowedExt.includes(fileExtension);
            const isMimeValid = allowedMimeTypes.includes(file.type);

            // 双重通过才算验证通过
            return isExtValid && isMimeValid;
        },
        /**
         * 上传资料文件
         * @param event
         * @param n
         */
        onFileDataChange(event,n){
            const file =  event.target.files[0];
            this.fileName = ''
            if(!this.validateZipRarFile(file)){
                Message.warning('只能上传.zip或.rar文件！')
                this.$refs.model.value = ''
                return
            }
            this.fileName = file.name
            this.speedVisible = true
            this.completeAsync = 0
            onAsynUploadFiles([file],systemUploadType.knowledge_image).then((data)=>{
                let fileName = []
                for(let i in data){
                    fileName.push(data[i].resourceName)
                }
                this.onFileUploadProgressService(fileName,n).then()
            }).catch(()=>{
                this.speedVisible = false
                this.complete = 0
                this.$refs.model.value = ''
                Message.error('上传失败，请重新尝试！')
            })
        },
        /**
         * 文件上传 进度查询
         */
        async onFileUploadProgressService(resourceNames,n) {
            try {
                let params = {
                    resourceNames:resourceNames,
                }
                const { code,data } = await getFileUploadProgressService(params)
                if(code === 'SUCCESS'){
                    if(data === 100){
                        this.completeAsync = 100
                        this.modelEditParams.filePath = resourceNames[0]
                        this.$refs.model.value = ''
                    }else{
                        if(data>=this.completeAsync){
                            this.completeAsync = data
                        }
                        setTimeout(()=>{
                            this.onFileUploadProgressService(resourceNames,n).then()
                        },2000)
                    }
                }else if(code === 'FILE_UPLOAD_FAILED'){
                    Message.error('上传失败,请重新尝试！')
                    this.$refs.model.value = ''
                }else{
                    Message.error('请求异常，请联系管理员！')
                }

            }catch (error){
                console.log(error)
            }
        },
        /**
         * 查询模型列表
         */
        async onModelList() {
            try {
                this.modelLoading = true
                this.modelListArray = {}
                let params = {
                    name:this.modelListParams.name,
                    displayNumber:this.modelListParams.displayNumber,
                    currentPage:this.modelListParams.currentPage
                }
                const { code,data } = await getModelListService(params)
                if(code === 'SUCCESS'){
                    this.modelListArray = data
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.modelLoading = false
            }catch (error){
                this.modelLoading = false
                console.log(error)
            }
        },
        /**
         * 添加模型
         */
        async onAddBusinessService() {
            try {
                this.editLoading = true
                let params = {
                    name:this.modelEditParams.name,
                    filePath:this.modelEditParams.filePath,
                }
                const { code } = await addModelService(params)
                if(code === 'SUCCESS'){
                    this.modelModalVisible = false
                    this.onModelList().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.editLoading = false
            }catch (error){
                this.editLoading = false
                console.log(error)
            }
        },
        /**
         * 修改模型
         */
        async onUpdateModelService() {
            try {
                this.editLoading = true
                let params = {
                    id:this.modelEditParams.id,
                    name:this.modelEditParams.name,
                    filePath:this.modelEditParams.filePath,
                }
                const { code } = await updateModelService(params)
                if(code === 'SUCCESS'){
                    this.modelModalVisible = false
                    this.onModelList().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.editLoading = false
            }catch (error){
                this.editLoading = false
                console.log(error)
            }
        },
        /**
         * 修改模型
         */
        async onDelModelService(id) {
            try {
                let params = {
                    id:id,
                }
                const { code } = await delModelService(params)
                if(code === 'SUCCESS'){
                    for(let i in this.modelListArray.content){
                        if(this.modelListArray.content[i].id === id){
                            this.modelListArray.content.splice(i,1)
                        }
                    }
                    Message.success('删除成功！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        /**
         * 批量下载资料文件
         */
        async onFileDownLoadService(id,name,row) {
            try {
                this.modelLoading = true
                let fileName = name === 'batch'?'ai模型':row.name
                let params = {
                    idList:id
                }
                const data = await getFileAiModelDownLoadService(params)
                Message.success('已下载！')
                downLoadBatch(fileName,data)
                this.modelLoading = false
            }catch (error){
                this.modelLoading = false
                console.log(error)
            }
        },
    },
    destroyed () {
        window.removeEventListener('resize',this.onTableHeight)
    }
}
export default ModelList
